import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Newsletter as NewsletterController } from "../../../../api";
import { initialValues, validationSchema } from "./Newsletter.form";
import { useLanguage } from "../../../../contexts";
import "./Newsletter.scss";

const newsletterController = new NewsletterController();

export function Newsletter() {
  const [successs, setSuccesss] = useState(false);
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      setSuccesss(false);

      try {
        await newsletterController.registerEmail(formValue.email);
        formik.resetForm();
        setSuccesss(true);
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <div className="footer-newsletter">
      <h4>{t("sign_up_and_learn")}</h4>

      <Form onSubmit={formik.handleSubmit}>
        <Form.Input
          name="email"
          placeholder={t("email")}
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          {t("subscribe")}
        </Form.Button>

        {successs && (
          <p className="success">{t("email_registered_successfully")}</p>
        )}
      </Form>
    </div>
  );
}
